export class ConversationSummaryDto {
  id: number;
  topic: string;
  summary: string;
  conversationResult: string;
  nonResolutionRisk: string;
  actions: string;
  churnRisk: string;
  error: string;
  statusId: number;
}
